import { css } from "emotion";

const wrapper = css`
  border-bottom: solid 2px #dedede;
  margin-bottom: 24px;
  height: 27px;
  @media (max-width: 700px) {
    height: 24px;
  }
`;

const list = css`
  list-style-type: none;
  margin-bottom: 0;
  margin-top: 0;
`;
const listElement = css`
  display: inline-block;
  margin-right: 32px;
  cursor: pointer;
  margin-top: 0;
`;

const listElementActive = css`
  ${listElement};
  border-bottom: 3px solid #2074d9;
`;

const link = css`
  color: #323232;
  &:hover {
    color: #6621c0;
    text-decoration: none;
  }
`;

const linkActive = css`
  ${link};
  font-weight: 600;
  color: #2074d9;
  &:hover {
    color: #2074d9;
  }
`;

const TabBar = ({ options, selected, changeTab }) => {
  return (
    <div className={wrapper}>
      <ul className={list}>
        {options.map((option, i) => {
          const isSelected = option.value === selected;
          return (
            <li
              key={i}
              className={isSelected ? listElementActive : listElement}
              onClick={() => changeTab(option.value)}
            >
              <a className={isSelected ? linkActive : link}>{option.label}</a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default TabBar;



// WEBPACK FOOTER //
// ./components/TabBar.js